import Joi from 'joi';
import { texts } from 'utils/languages/fr';
import { EMAIL_VALIDATION_OPTIONS } from '../../utils/constants';

const SGPFormSchema = {
    name: Joi.string().trim().required().min(2).max(120).messages({
        'string.empty': texts.SAISIR_LE_CHAMP,
        'string.min': texts.SAISIR_LE_CHAMP,
        'string.max': texts.SAISIR_LE_CHAMP,
    }),
    logo: Joi.any().invalid(null).messages({
        'any.invalid': texts.SAISIR_LE_CHAMP,
    }),
    rcsNumber: Joi.string().trim().required().messages({
        'string.empty': texts.SAISIR_LE_CHAMP,
    }),
    rcsRegistrationAddress: Joi.string().trim().required().messages({
        'string.empty': texts.SAISIR_LE_CHAMP,
    }),
    amfData: Joi.string().trim().required().messages({
        'string.empty': texts.SAISIR_LE_CHAMP,
    }),
    legalRepresentativeName: Joi.string().trim().required().messages({
        'string.empty': texts.SAISIR_LE_CHAMP,
    }),
    legalRepresentativeFunction: Joi.string().trim().required().messages({
        'string.empty': texts.SAISIR_LE_CHAMP,
    }),
    contactEmail: Joi.string().email(EMAIL_VALIDATION_OPTIONS).required().messages({
        'string.empty': texts.SAISIR_LE_CHAMP,
        'string.email': texts.ADRESSE_EMAIL_SAISIE_PAS_VALIDE,
    }),
    distributorBillEmail: Joi.string().email(EMAIL_VALIDATION_OPTIONS).required().messages({
        'string.empty': texts.SAISIR_LE_CHAMP,
        'string.email': texts.ADRESSE_EMAIL_SAISIE_PAS_VALIDE,
    }),
    documentsFooterText: Joi.string().trim().required().messages({
        'string.empty': texts.SAISIR_LE_CHAMP,
    }),
    signatureImage: Joi.any().invalid(null).messages({
        'any.invalid': texts.SAISIR_LE_CHAMP,
    }),
    currentAddress: {
        address: Joi.string().required().messages({
            'any.required': texts.VEUILLEZ_SAISIR_VOTRE_ADDRESS,
            'string.empty': texts.VEUILLEZ_SAISIR_VOTRE_ADDRESS,
        }),
        zipCode: Joi.string().required().messages({
            'any.required': texts.VEUILLEZ_SAISIR_LE_CODE_POSTAL,
            'string.empty': texts.VEUILLEZ_SAISIR_LE_CODE_POSTAL,
        }),
        city: Joi.string().required().messages({
            'any.required': texts.VEUILLEZ_SAISIR_LA_VILLE,
            'string.empty': texts.VEUILLEZ_SAISIR_LA_VILLE,
        }),
    },
    bankIdentifier: Joi.string().trim().required().messages({
        'string.empty': texts.SAISIR_LE_CHAMP,
        'any.required': texts.SAISIR_LE_CHAMP,
    }),
};

export default SGPFormSchema;
